import React, { Component } from 'react';
import Papa from 'papaparse';
import {
  BootstrapTable,
  TableHeaderColumn
} from 'react-bootstrap-table';
import * as XLSX from 'xlsx';
import MaskedInput from 'react-maskedinput';
import { formatMsisdn, numeric, real } from '../utils/Helper';
import { Message } from '../locale/Message';
import { realNumRegex } from '../utils/Regexes';

class InsertModal extends React.Component {
  constructor() {
    super();
    this.state = {
      msisdn: '',
      account: '',
      invoice: '',
      amount: '',
      error: ''
    };
  }

  getFilledField = () => {
    const { msisdn, account, invoice } = this.state;

    if (numeric(msisdn).length > 0) return 'msisdn';
    if (String(account || '').trim()) return 'account';
    if (String(invoice || '').trim()) return 'invoice';

    return null;
  };

  handleSaveBtnClick = () => {
    const { lang, data } = this.props;
    const { msisdn, account, invoice, amount } = this.state;

    const msisdnNorm = formatMsisdn(numeric(msisdn));
    const accountNorm = String(account || '').trim();
    const invoiceNorm = String(invoice || '').trim();

    const filledCount = [
      numeric(msisdn).length >= 11,
      !!accountNorm,
      !!invoiceNorm
    ].filter(Boolean).length;

    if (filledCount !== 1 || amount === '') {
      this.setState({ error: Message[lang].require_all_fiels });
      return;
    }

    if (real(amount) === 'error') {
      this.setState({ error: Message[lang].null_amount });
      return;
    }

    if (
      numeric(msisdn).length >= 11 &&
      data.some(r => numeric(r.msisdn) === numeric(msisdnNorm))
    ) {
      this.setState({ error: Message[lang].number_already_exist });
      return;
    }

    if (
      accountNorm &&
      data.some(r => String(r.account || '').trim() === accountNorm)
    ) {
      this.setState({
        error:
          Message[lang].account_already_exist ||
          Message[lang].same_numbers_in_file
      });
      return;
    }

    if (
      invoiceNorm &&
      data.some(r => String(r.invoice || '').trim() === invoiceNorm)
    ) {
      this.setState({
        error:
          Message[lang].invoice_already_exist ||
          Message[lang].same_numbers_in_file
      });
      return;
    }

    const newRow = {
      id: `${Date.now()}_${Math.random()}`,
      msisdn: numeric(msisdn).length >= 11 ? msisdnNorm : '',
      account: accountNorm,
      invoice: invoiceNorm,
      amount: amount,
      status: ''
    };

    this.props.onSave(newRow);
  };

  render() {
    const { error } = this.state;
    const { onModalClose, columns, lang } = this.props;

    const filledField = this.getFilledField();

    const isMsisdnDisabled =
      !!filledField && filledField !== 'msisdn';
    const isAccountDisabled =
      !!filledField && filledField !== 'account';
    const isInvoiceDisabled =
      !!filledField && filledField !== 'invoice';

    return (
      <div className="modal-content react-bs-table-insert-modal">
        <div className="modal-body">
          <div className="form-group">
            <label>{Message[lang].registry_field_number}</label>
            <MaskedInput
              mask="+7 111 111 11 11"
              type="text"
              value={this.state.msisdn}
              disabled={isMsisdnDisabled}
              className="form-control editor edit-text"
              onChange={s =>
                this.setState({
                  msisdn: s.target.value,
                  error: ''
                })
              }
            />
          </div>

          <div className="form-group">
            <label>{Message[lang].registry_field_account}</label>
            <input
              type="text"
              className="form-control editor edit-text"
              value={this.state.account}
              disabled={isAccountDisabled}
              onChange={s =>
                this.setState({
                  account: s.target.value,
                  error: ''
                })
              }
            />
          </div>

          <div className="form-group">
            <label>{Message[lang].registry_field_invoice}</label>
            <input
              type="text"
              className="form-control editor edit-text"
              value={this.state.invoice}
              disabled={isInvoiceDisabled}
              onChange={s =>
                this.setState({
                  invoice: s.target.value,
                  error: ''
                })
              }
            />
          </div>

          <div className="form-group">
            <label>{Message[lang].registry_field_amount}</label>
            <input
              type="text"
              className="form-control editor edit-text"
              value={this.state.amount}
              onChange={s =>
                realNumRegex.test(s.target.value) &&
                this.setState({
                  amount: s.target.value,
                  error: ''
                })
              }
            />
          </div>
        </div>

        <div className="modal-footer">
          {error ? (
            <div className="form-group">
              <div className="col-xs-12 alert alert-danger">
                {error}
              </div>
            </div>
          ) : (
            ''
          )}

          <span>
            <button
              type="button"
              id="btn-primary"
              className="btn"
              onClick={onModalClose}
            >
              {Message[lang].close}
            </button>

            <button
              type="button"
              className="btn btn-primary"
              onClick={this.handleSaveBtnClick}
            >
              {Message[lang].save}
            </button>
          </span>
        </div>
      </div>
    );
  }
}

class ERegistryNumbers extends Component {
  createModal = (
    onModalClose,
    onSave,
    columns,
    validateState,
    ignoreEditable
  ) => {
    const { data, lang } = this.props;
    const attr = {
      onModalClose,
      onSave,
      columns,
      validateState,
      ignoreEditable,
      data,
      lang
    };
    return <InsertModal {...attr} />;
  };

  renderResult = data => {
    const { onDataChange, lang } = this.props;

    if (!data) {
      onDataChange([], Message[lang].invalid_file_format);
      return;
    }

    if (!data.length) {
      onDataChange([], Message[lang].invalid_file_format);
      return;
    }

    if (data.length > 3500) {
      onDataChange([], Message[lang].numbers_has_been_exceeded);
      return;
    }

    if (this.hasDuplicates(data)) {
      onDataChange([], Message[lang].same_numbers_in_file);
      return;
    }

    onDataChange(data);
  };
  normalizeRow(row) {
    const msisdnRaw = row[0];
    const accountRaw = row[1];
    const invoiceRaw = row[2];
    const amountRaw = row[3];

    const msisdnDigits = numeric(msisdnRaw || '');
    const msisdn =
      msisdnDigits.length >= 11 ? formatMsisdn(msisdnDigits) : '';

    const account = String(accountRaw ?? '').trim();
    const invoice = String(invoiceRaw ?? '').trim();

    const amountParsed = real(String(amountRaw ?? '').trim());
    const amount = amountParsed === 'error' ? 'error' : amountParsed;

    const hasAnyId = !!msisdn || !!account || !!invoice;

    return {
      id: `${Date.now()}_${Math.random()}`,
      msisdn,
      account,
      invoice,
      amount,
      status: '',
      _hasAnyId: hasAnyId
    };
  }
  hasDuplicates(rows) {
    const seenMsisdn = new Set();
    const seenAccount = new Set();
    const seenInvoice = new Set();

    for (const r of rows) {
      if (r.msisdn) {
        const k = numeric(r.msisdn);
        if (seenMsisdn.has(k)) return true;
        seenMsisdn.add(k);
      }
      if (r.account) {
        const k = String(r.account).trim();
        if (seenAccount.has(k)) return true;
        seenAccount.add(k);
      }
      if (r.invoice) {
        const k = String(r.invoice).trim();
        if (seenInvoice.has(k)) return true;
        seenInvoice.add(k);
      }
    }

    return false;
  }

  convert(data) {
    const rows = data || [];
    if (!rows.length) return [];

    const normalizeHeader = v =>
      String(v ?? '')
        .toLowerCase()
        .replace(/ё/g, 'е')
        .replace(/\s+/g, ' ')
        .trim();

    const h0 = normalizeHeader(rows[0]?.[0]);
    const h1 = normalizeHeader(rows[0]?.[1]);
    const h2 = normalizeHeader(rows[0]?.[2]);
    const h3 = normalizeHeader(rows[0]?.[3]);

    // Строгая проверка заголовков и порядка колонок:
    const isStrictHeader =
      (h0.includes('номер') || h0.includes('абонент')) &&
      (h1.includes('лицев') || h1.includes('счет')) &&
      (h2.includes('счет-фак') ||
        h2.includes('счет фак') ||
        h2.includes('invoice')) &&
      (h3.includes('сумм') || h3.includes('amount'));

    // Если первая строка "похожа на заголовок", но порядок НЕ тот — считаем формат неверным
    const looksLikeAnyHeader =
      [h0, h1, h2, h3].join(' ').includes('номер') ||
      [h0, h1, h2, h3].join(' ').includes('сумм') ||
      [h0, h1, h2, h3].join(' ').includes('amount') ||
      [h0, h1, h2, h3].join(' ').includes('invoice') ||
      [h0, h1, h2, h3].join(' ').includes('лицев') ||
      [h0, h1, h2, h3].join(' ').includes('счет');

    if (looksLikeAnyHeader && !isStrictHeader) {
      // вернём пусто — renderResult покажет invalid_file_format
      return [];
    }

    const dataRows = isStrictHeader ? rows.slice(1) : rows;

    return dataRows
      .map(r => this.normalizeRow(r))
      .filter(r => r.amount && r.amount !== 'error')
      .filter(r => r._hasAnyId)
      .map(r => {
        const { _hasAnyId, ...rest } = r;
        return rest;
      });
  }

  onFileGet = event => {
    const file = event.target.files[0];
    if (file) {
      const name = file.name;
      const { onDataChange, lang } = this.props;
      let data = [];
      if (name.includes('.csv')) {
        Papa.parse(file, {
          skipEmptyLines: true,
          delimiter: ';',
          complete: results => {
            if (results.data) {
              data = this.convert(results.data);
            }
            Papa.parse(file, {
              skipEmptyLines: true,
              delimiter: ',',
              complete: results => {
                if (results.data && !data[0]) {
                  data = this.convert(results.data);
                }

                this.renderResult(data);
              }
            });
          }
        });
      } else if (name.includes('xls') || name.includes('xlsx')) {
        const reader = new FileReader();
        reader.onload = event => {
          const bstr = event.target.result;
          const wb = XLSX.read(bstr, { type: 'binary' });
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          var data = XLSX.utils.sheet_to_json(ws, { header: 1 });
          if (data && data[0]) {
            data = this.convert(data);
          }
          this.renderResult(data);
        };
        reader.readAsBinaryString(file);
      } else {
        onDataChange([], Message[lang].invalid_file_format);
      }

      event.target.value = '';
    }
  };

  onDeleteRow = ids => {
    this.props.onDataChange(
      this.props.data.filter(i => !ids.includes(i.id))
    );
  };

  onAddRow = row => {
    const { data, onDataChange, lang } = this.props;

    if (data.length >= 2500) {
      onDataChange(
        [...data],
        Message[lang].numbers_has_been_exceeded
      );
      return;
    }

    const newRow = {
      id: `${Date.now()}_${Math.random()}`,
      msisdn: row.msisdn || '',
      account: row.account || '',
      invoice: row.invoice || '',
      amount: row.amount || '',
      status: row.status || ''
    };

    onDataChange([...data, newRow]);
  };

  styledCell = (cell, row) => {
    const text = cell || '';
    let cls = '';

    if (row.applyStyle === 'error') cls = 'text-danger';
    if (row.applyStyle === 'success') cls = 'status-success';

    return `<span class="ereg-status-text ${cls}" title="${text}">${text}</span>`;
  };

  render() {
    const { lang } = this.props;
    const selectRowProp = {
      mode: 'checkbox',
      bgColor: 'rgb(238, 193, 213)'
    };

    return (
      <div>
        <div className="form-group" style={{ marginLeft: '-14px' }}>
          <div className="input-item col-xs-12">
            <label className="btn-primary btn">
              {Message[lang].choose_file_registry}
              <input
                type="file"
                accept=".csv, .xls, .xlsx"
                onChange={this.onFileGet}
                multiple
                style={{ display: 'none' }}
              />
            </label>
            <h6 className="small text-rich-purple">
              {Message[lang].e_registry_before_upload}
            </h6>
          </div>
        </div>

        <BootstrapTable
          data={this.props.data}
          insertRow={true}
          deleteRow={true}
          remote={true}
          selectRow={selectRowProp}
          options={{
            onAddRow: this.onAddRow,
            insertText: Message[lang].add,
            deleteText: Message[lang].delete,
            handleConfirmDeleteRow: deleteRow => deleteRow(),
            onDeleteRow: this.onDeleteRow,
            insertModal: this.createModal
          }}
        >
          <TableHeaderColumn dataField="id" isKey hidden>
            ID
          </TableHeaderColumn>

          <TableHeaderColumn dataField="msisdn">
            {Message[lang].number}
          </TableHeaderColumn>

          <TableHeaderColumn dataField="account">
            {Message[lang].account}
          </TableHeaderColumn>

          <TableHeaderColumn dataField="invoice">
            {Message[lang].invoice}
          </TableHeaderColumn>

          <TableHeaderColumn dataField="amount">
            {Message[lang].sum}
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="status"
            editable={false}
            dataFormat={this.styledCell}
            columnClassName="ereg-status-col"
            tdStyle={{ whiteSpace: 'normal' }}
            thStyle={{ whiteSpace: 'normal' }}
          >
            {Message[lang].status}
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    );
  }
}

export default ERegistryNumbers;
